/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import PageHeader from '@atlaskit/page-header';
import { useHref } from 'react-router';
import { useIntl } from 'components/i18n';
import { RecurringSale } from '../types';
import SaleStatus from './SaleStatus';
import RecurringSaleStatus from './RecurringSaleStatus';

type Props = {
  recurringSale: Partial<RecurringSale> | null;
  isNew: boolean;
}

const SaleEditHeader: React.FC<Props> = ({recurringSale, isNew}) => {

  const recurringSalesHref = useHref('../../');
  const recurringSaleViewHref = useHref('../');

  const intl = useIntl();

  if (!recurringSale) {
    return null
  }

  const path = intl.formatMessage({
    id: 'common.recurringInvoices',
    defaultMessage: 'Recurring invoices',
  });

  const titleNew = intl.formatMessage({
    id: 'sale.RecurringSaleEditHeader.title.new',
    defaultMessage: 'New recurring invoice',
  });

  const titleEdit = intl.formatMessage({
    id: 'sale.RecurringSaleEditHeader.recurringInvoices.title.edit',
    defaultMessage: 'Edit recurring invoice',
  });

  return (<PageHeader
   /* breadcrumbs={
      <BreadcrumbsStateless onExpand={() => {
      }}>
        <BreadcrumbsItem text={path} key={path} href={recurringSalesHref}/>
        {/!*<BreadcrumbsItem*!/}
        {/!*  href={recurringSaleViewHref}*!/}
        {/!*  text={recurringSale?.invoiceNumber || ''}*!/}
        {/!*  key={recurringSale?.invoiceNumber || ''}*!/}
        {/!*!/>*!/}
      </BreadcrumbsStateless>
    }*/
  >
    <span css={css`display: flex; align-items: center;`}>
              {isNew ? titleNew : titleEdit}
      <div css={css`margin-left: 0.25rem;`}><RecurringSaleStatus isActive={recurringSale.isActive}/></div>
        </span>
  </PageHeader>);

};

export default SaleEditHeader;
